import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';
import { lastValueFrom } from 'rxjs';

const baseRoute = '/operation/sales/detail';

@Injectable({
  providedIn: 'root'
})
export class SaleDocumentService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
  async exportDetails(filterDate = 'today') {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'POST',
          url: '/operation/sales/detail/export',
          data: { filterDate }
        })
      );

      return this.refactorResponse(response);
    } catch (error) {
      console.error('Error al exportar detalles de venta:', error);
      return this.refactorErrorResponse(error);
    }
  }
}
